import { PlaceholderPage } from './PlaceholderPage';

/**
 * /admin/networks — Network class admin (chamber-of-commerce groupings).
 * Placeholder (31 May 2026). Concept ideation lives at
 * `@IDEATION/Nexanomics_Network_Class_Ideation_v1.docx`. Real
 * implementation deferred until the Networks concept is locked into
 * a reference doc + ADR (Phase 6+).
 */
export function NetworksPage() {
  return (
    <PlaceholderPage
      title="Networks"
      plannedPhase="Phase 6+"
      intent={
        <>
          Networks are groupings of partners who share affinity — by
          geography (Adelaide, Sydney CBD), industry (digital agencies),
          or member organisation (BNI chapters, chambers of commerce).
          A subscriber joins one or more networks, communicates with
          its members, and invites new partners in. This page is the
          admin surface for creating networks, approving / removing
          members, and viewing membership graphs. Concept ideation at{' '}
          <code>@IDEATION/Nexanomics_Network_Class_Ideation_v1.docx</code>.
        </>
      }
      features={[
        'Create / rename / archive networks',
        'Approve membership requests; remove members',
        'Network membership graph view (who belongs to what)',
        'Per-network analytics: member count, intra-network referrals',
        'Geographic / industry tagging for network discovery',
      ]}
    />
  );
}
